import loginFetch from "./loginFetch";
import gptFetch from "./gptFetch";
import libraryFetch from "./libraryFetch";
import botServiceFetch from "./botServiceFetch";
import botPostsFetch from "./botPostsFetch";
import teamFetch from "./teamFetch";
import botEmailsFetch from "./botEmailsFetch";
import aboutFbFetch from "./aboutFbFetch";
import templateManageFetch from "./templateManageFetch.js";
import * as translateFetch from "./translateFetch";
import whatsApp from "./whatsApp.js";
import classifyTagsFetch from "./classifyTagsFetch.js";
import user from "./user";
import { getCurrencyList } from "./currencyList";
import publicSentimentFetch from "./publicSentimentFetch";
import publisherFetch from "./publisherFetch";
import socialStatistics from "./socialStatistics.js";
import socialListeningFetch from "./socialListeningFetch.js";
import dataSummaryFetch from "./dataSummaryFetch.js";
import pageLabelFetch from "./pageLabelFetch.js";
import * as couponFetch from "./couponFetch.js";

export default {
  ...gptFetch,
  ...libraryFetch,
  ...loginFetch,
  ...botServiceFetch,
  ...botPostsFetch,
  ...teamFetch,
  ...botEmailsFetch,
  ...aboutFbFetch,
  ...templateManageFetch,
  ...translateFetch,
  ...whatsApp,
  ...classifyTagsFetch,
  ...user,
  ...publicSentimentFetch,
  ...publisherFetch,
  getCurrencyList,
  ...socialStatistics,
  ...socialListeningFetch,
  ...dataSummaryFetch,
  ...pageLabelFetch,
  // 优惠券任务接口集中由 couponFetch 提供，页面通过全局 $axios 复用。
  ...couponFetch,
};
